import { useEffect, useState } from "react";

import EditCollege from "./collegeEdit";
import { connect, useDispatch } from "react-redux";
import { getColleges } from "../../../../../action/common/commonActionCreator";
import { getCollege } from "../../../../../action/masters/collegeActionCreator";
import { cloneDeep, baseURL } from "../../../../../constants/commonConstants";
import {
  ICollegeDetails,
  ICollegeData,
} from "../../../../../models/master/college";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import { setCollege } from "../../../../../store/slices/master/collegeSlice";

const CollegeDetails = (props: ICollegeDetails) => {
  const { getCollege, college } = props;
  const [data, setData] = useState<ICollegeData>(cloneDeep(college));
  const [showEdit, setShowEdit] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const getCollegeData = async () => {
    setIsLoading(true);
    try {
      await getCollege();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCollegeData();
  }, []);

  useEffect(() => {
    if (college) {
      setData(cloneDeep(college));
    }
  }, [college]);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getCollege(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setCollege([]));
    };
  }, []);

  return (
    <>
      <div className="admin-wrap">
        <div className="admincontent">
          <div className="title">
            <h2>University Management Details</h2>
            {data && (
              <a
                href="javascript:void(0)"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#editdepartement"
                onClick={() => editItem(data.id ?? 0)}
              >
                <img
                  src="/assets/images/icon/edit-wh.svg"
                  alt=""
                  className="me-2"
                />
                Edit Details
              </a>
            )}
          </div>
          {isLoading ? (
            <LoaderSpinner />
          ) : (
            data && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <p>
                      <img
                        src={
                          data?.collegeLogo ? baseURL + data.collegeLogo : ""
                        }
                        style={{ width: "150px", height: "150px" }}
                        className="mb-3"
                        alt=""
                      />
                    </p>

                    <div className="row">
                      <div className="col-lg-6 label-group">
                        <label>University Management Name</label>
                        <p>{data.collegeName}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Address</label>
                        <p>{data.address}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Location</label>
                        <p>{data.location}</p>
                      </div>
                      <div className="col-lg-12 label-group">
                        <label>Description</label>
                        <p>{data.description}</p>
                      </div>
                      <div className="col-lg-6 label-group">
                        <label>Login User Name</label>
                        <p>{data.collegeLoginUserName}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <EditCollege
            setShowEdit={handleEditClose}
            college={college}
            isCollegeAdmin={true}
            getCollege={getCollegeData}
          />
        </ReactModal>
      )}
    </>
  );
};

const mapDispatchToProps = {
  getCollege: (id?: number) => getCollege(id),
  getColleges: () => getColleges(),
};

function mapStateToProps(state: any) {
  return {
    college: state.college.college,
    colleges: state.college.colleges,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollegeDetails);
